import { useEffect } from 'react';
import { Stack } from 'expo-router';
import { useMMKVString } from 'react-native-mmkv';
import { observer } from 'mobx-react';

import LoginScreen from '@/components/LoginScreen';
import { storage } from '@/services/auth/authStorage';
import { useStores } from '@/stores/StoreProvider';

export default observer(function MainLayout() {
  const [token] = useMMKVString('access_token', storage);
  const { userStore } = useStores();

  useEffect(() => {
    if (token && !userStore.isLoaded) {
      userStore.fetchUser();
    }
  }, [token, userStore]);

  if (!token) {
    return <LoginScreen />;
  }

  return (
    <Stack>
      <Stack.Screen name="index" options={{ headerShown: false }} />
      <Stack.Screen name="settings" options={{ headerShown: false }} />
      <Stack.Screen name="subscribe" options={{ headerShown: false }} />
    </Stack>
  );
});
